import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';

export default [
  <ShowocaseLayout
    key="/business/showcase/shadefinder/home"
    exact
    path="/business/showcase/shadefinder/home"
    component={AsyncPage}
  />,
];
